export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return undefined;
};

export const setCookie = (name, value, days = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

// Removes Cognito cookies from previous users/sessions that accumulate under the
// shared cookie domain and can cause RequestHeaderSectionTooLarge (>8KB) errors.
export const deleteStaleAuthCookies = (appClientId, currentUserId, cookieDomain) => {
  const base = `CognitoIdentityServiceProvider.${appClientId}`;
  const lastAuthUserKey = `${base}.LastAuthUser`;
  const currentPrefix = `${base}.${currentUserId}.`;

  document.cookie.split('; ').forEach((rawCookie) => {
    const eqIndex = rawCookie.indexOf('=');
    if (eqIndex === -1) return;
    const name = decodeURIComponent(rawCookie.substring(0, eqIndex));

    if (!name.startsWith(base)) return;
    if (name === lastAuthUserKey || name.startsWith(currentPrefix)) return;

    const expiry = 'Thu, 01 Jan 1970 00:00:00 UTC';
    if (cookieDomain) {
      document.cookie = `${name}=;expires=${expiry};path=/;domain=${cookieDomain}`;
    }
    document.cookie = `${name}=;expires=${expiry};path=/`;
  });
};
